export default __webpack_public_path__ + "static/media/celluloid.722346f4.svg";